export default __webpack_public_path__ + "static/media/Picture 1.58c73acb.svg";